<template>
  <section>
    <!-- Multiple registries: tab toggle -->
    <b-tabs
      v-if="registries.length > 1"
      :value="activeIndex"
      type="is-toggle"
      size="is-small"
      class="registry-tabs mb-0"
      @input="onTabChanged"
    >
      <b-tab-item
        v-for="registry in registries"
        :key="registry.id"
        :label="registry.name"
      />
    </b-tabs>

    <!-- Single registry: static badge -->
    <span v-else-if="registries.length === 1" class="is-flex is-align-items-center" style="gap: 0.5rem">
      <b-icon icon="book-open-variant" size="is-small" />
      <span class="title is-6 mb-0">{{ registries[0].name }}</span>
    </span>
  </section>
</template>

<script>
import { rawObject } from "@/helpers/utils";

export default {
  name: "RegistriesSelector",
  props: {
    registries: {
      type: Array,
      default: () => [],
    },
    currentRegistry: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    activeIndex() {
      if (!this.currentRegistry || !this.registries.length) return 0;
      const idx = this.registries.findIndex((r) => r.id === this.currentRegistry.id);
      return idx >= 0 ? idx : 0;
    },
  },
  methods: {
    onTabChanged(index) {
      const registry = this.registries[index];
      if (registry) {
        this.$emit("handleChangedRegister", rawObject(registry.id));
      }
    },
  },
};
</script>

<style scoped>
.registry-tabs ::v-deep .tabs {
  margin-bottom: 0;
}
.registry-tabs ::v-deep nav.tabs {
  margin-bottom: 0;
}
</style>
